/* eslint-disable react/prop-types */
import { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { Button } from 'react-bootstrap';

class QuizIndicator extends Component {
  state = {
    dismissed: false,
  };

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        dismissed: true,
      });
    }, 5000);
  }

  handleClick = () => {
    this.props.onClick();
    this.setState({
      dismissed: true,
    });
  };

  render() {
    return (
      <ReactCSSTransitionGroup
        transitionName="fade"
        transitionAppear
        transitionAppearTimeout={100}
        transitionEnterTimeout={500}
        transitionLeaveTimeout={500}
      >
        {!this.state.dismissed ? (
          <Button
            className="quiz-indicator"
            bsStyle="primary"
            onClick={this.handleClick}
          >
            complete <b>activity</b> to continue
            <b className="arrow-down">
              <i className="icon-ion-chevron-down" />
            </b>
          </Button>
        ) : null}
      </ReactCSSTransitionGroup>
    );
  }
}

export default QuizIndicator;
